import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable, switchMap, tap, throwError } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { UtilsService } from '../../services/utils/utils.service';

@Injectable({
  providedIn: 'root'
})

export class AuthService {
  private readonly base_url = environment.api_url;
  private readonly tokenKey = 'authToken';
  private readonly isLoggedInSubject = new BehaviorSubject<boolean>(this.hasToken());

  constructor(
    private readonly http: HttpClient,
    private readonly router: Router,
    private readonly utils: UtilsService
  ) {}

  login(username: string, password: string): Observable<any> {
    return this.http.post<any>(
      `${this.base_url}/api/auth/login`,
      { 
        username, 
        password,
        agent: 'web' 
      }
    ).pipe(
      switchMap(res => {
        if (res?.data?.error) {
          return throwError(() => new Error(res.data.error));
        }

        const token = res?.data?.token;
        if (token) {
          this.utils.saveAuthToken(token, res.data.refresh);
          this.isLoggedInSubject.next(true);
          return this.getUserProfile();
        } else {
          return throwError(() => new Error('Token not found in response'));
        }
      })
    );
  }

  logout(reason: string = ''): void {
    this.utils.clearAuth();
    this.isLoggedInSubject.next(false);
    this.router.navigate(['/login'], {
      queryParams: reason ? { reason } : {}
    });
  }

  getToken(): string | null {
    return localStorage.getItem(this.tokenKey);
  }

  
  refreshToken(): Observable<any> {
    const refresh = localStorage.getItem('refreshToken');
    if(this.utils.isValidToken(refresh)){
      return this.http.post<any>(
        `${this.base_url}/api/token/refresh`, {
          refresh
        }
      );
    } else {
      return throwError(() => new Error('Invalid or Expired Token'));
    }
  }

  isLoggedIn(): Observable<boolean> {
    return this.isLoggedInSubject.asObservable();
  }

  private hasToken(): boolean {
    return !!localStorage.getItem(this.tokenKey);
  }

  getUserRole(): string | null {
    const user = JSON.parse(localStorage.getItem('user') ?? '{}');
    return user.role ?? null;
  }

  getUserProfile(): Observable<any> {
    return this.http.get<any>(`${this.base_url}/api/users/get-profile`).pipe(
      tap(res => {
        if (res?.data) {
          localStorage.setItem('user', JSON.stringify(res.data));
        }
      })
    );
  }
}
